import Alert from './components/common/Alert';
import './templates.scss';

const getMitArretierung = (artikel: Artikel): ArtikelVariationWert | undefined => {
  const seitlicheArretierung = artikel.variationen.find((variation) => variation.cName.toLowerCase().includes('arretierung'));
  return seitlicheArretierung?.Werte.find((wert) => wert.cName.toLowerCase().includes('mit'));
};

const getOhneArretierung = (artikel: Artikel): ArtikelVariationWert | undefined => {
  const seitlicheArretierung = artikel.variationen.find((variation) => variation.cName.toLowerCase().includes('arretierung'));
  return seitlicheArretierung?.Werte.find((wert) => wert.cName.toLowerCase().includes('ohne'));
};

const templates: (artikel: Artikel, parameter?: any) => { [templateId: number]: React.ReactElement } = (artikel: Artikel, parameter?: any) => ({
  1: (
    <div>
      <div className="d-flex flex-row justify-content-around align-items-stretch">
        <div className="w-50 pr-1 d-flex flex-column align-items-center">
          <img
            className="w-100 p-1 templates__arretierung"
            src={`https://www.diwaro.de/media/image/storage/variations/${getMitArretierung(artikel)?.currentImagePath}`}
            alt={getMitArretierung(artikel)?.cName}
          />
          <div>
            <strong>Rolladenpanzer mit Arretierung</strong><br />
            (gegen seitliches Verschieben geschützt)
          </div>
        </div>
        <div className="w-50 pl-1 d-flex flex-column align-items-center">
          <img
            className="w-100 p-1 templates__arretierung"
            src={`https://www.diwaro.de/media/image/storage/variations/${getOhneArretierung(artikel)?.currentImagePath}`}
            alt={getOhneArretierung(artikel)?.cName}
          />
          <div>
            <strong>Rolladenpanzer ohne Arretierung</strong><br />
            (seitliches Verschieben ist möglich)
          </div>
        </div>
      </div>
      <div className="mt-3">
        Die PVC-Rollladenstäbe werden durch eine Stift-Arretierungen gegen seitliches Verschieben gesichert.
        Der Stift wird in einem Abstand von ca. 10 mm zum Rand in das Rolladenprofil geschossen.
        Hierdurch werden die Rolladenstäbe fixiert und können nicht mehr verrutschen. Durch den ausreichenden
        Abstand zum Rand wird das Laufverhalten des Rolladens nicht beeinträchtigt. Die Arretierung wird nach
        dem Einbau von der Führungsschiene verdeckt und ist somit nicht sichtbar. Bei normaler Bedienung kann
        sich die Arretierung nicht lösen.
      </div>
    </div>
  ),
  2: (
    <div className="mb-3 font-weight-bold templates__sonderfarben">
      Die Sonderfarben Holz hell, Holz dunkel und Oregon sind rohstoffbedingt nicht für die Verwendung an
      Gebäudeflächen mit intensiver Sonneneinstrahlung geeignet, da die Farbbeständigkeit, sowie die
      Standfestigkeit der Profile unter längerer Sonneneinstrahlung nicht mehr gegeben ist. Entsprechend
      kann auf diese Rolladenkombination keine Garantie gegeben werden!
    </div>
  ),
  3: (
    <div className="mb-3 font-weight-bold">
      Ab einer Rolladenbreite von 1950 mm müssen wir einen Speditionszuschlag erheben.
      Bei einer Rolladenbreite größer 2950 mm, muss der Rolladen am Lager abgeholt werden.
    </div>
  ),
  4: (
    <Alert severity="warning" key={4}>
      Die maximale Breite ({parameter} mm) für die Herstellergewährleistung wurde überschritten.
      <br />
      Sie können den Artikel bestellen, jedoch ohne Gewährleistung bei etwaigen mechanisch auftretenden Mängeln oder Beschädigungen.
    </Alert>
  ),
  5: (
    <Alert severity="warning" key={5}>
      Die maximale Fläche ({parameter} m²) für die Herstellergewährleistung wurde überschritten.
      <br />
      Sie können den Artikel bestellen, jedoch ohne Gewährleistung bei etwaigen mechanisch auftretenden Mängeln oder Beschädigungen.
    </Alert>
  ),
  6: (
    <Alert severity="error" key={6}>
      Die minimale Breite (300 mm) wurde unterschritten. Bitte wählen Sie ein anderes Maß.
    </Alert>
  ),
  7: (
    <Alert severity="error" key={7}>
      Die minimale Höhe (300 mm) wurde unterschritten. Bitte wählen Sie ein anderes Maß.
    </Alert>
  ),
  8: (
    <Alert severity="error" key={8}>
      Die maximale Höhe (3000 mm) wurde überschritten. Bitte wählen Sie ein anderes Maß.
    </Alert>
  ),
  9: (
    <Alert severity="warning" key={9}>
      Die maximale Breite (2950 mm) für den Speditionsversand wurde überschritten. Die Ware kann nur am Lager abgeholt werden!
    </Alert>
  ),
  10: (
    <Alert severity="error" key={10}>
      Die maximale Breite (5000 mm) wurde überschritten. Bitte wählen Sie ein anderes Maß.
    </Alert>
  ),
  11: (
    <Alert severity="warning" key={11}>
      Die maximale Breite (1950 mm) für den Standardversand wurde überschritten. Es wird ein Speditionszuschlag berechnet!
    </Alert>
  ),
  12: (
    <Alert severity="error" key={12}>
      Die minimale Länge (300 mm) wurde unterschritten. Bitte wählen Sie ein anderes Maß.
    </Alert>
  ),
  13: (
    <Alert severity="warning" key={13}>
      Die maximale Länge (2000 mm) für den Standardversand wurde überschritten. Es wird ein Speditionszuschlag berechnet! Sie können die Ware aber auch abholen.
    </Alert>
  ),
  14: (
    <Alert severity="warning" key={14}>
      Die maximale Länge (2800 mm) für den Speditionsversand wurde überschritten. Die Ware kann nur am Lager abgeholt werden!
    </Alert>
  ),
  15: (
    <Alert severity="error" key={15}>
      Die maximale Länge (6000 mm) wurde überschritten.
    </Alert>
  ),
  16: (
    <div className="mb-3 font-weight-bold">
      Ab einer Länge von 2000 mm müssen wir einen Speditionszuschlag erheben.
      Bei einer Länge größer 2800 mm, muss {parameter} am Lager abgeholt werden.
    </div>
  ),
  17: (
    <Alert severity="error" key={17}>
      Die Länge der Führungsschiene darf die Stauhöhe plus zusätzlicher Länge für die Spannhebel nicht unterschreiten. Mindestlänge: {parameter} mm.
    </Alert>
  ),
  18: (
    <Alert severity="error" key={18}>
      Die minimale Breite ({parameter} mm) wurde unterschritten. Bitte wählen Sie ein anderes Maß.
    </Alert>
  ),
  19: (
    <Alert severity="warning" key={19}>
      Die maximale Länge ({parameter} mm) für den Speditionsversand wurde überschritten. Die Ware kann nur am Lager abgeholt werden!
    </Alert>
  ),
  20: (
    <Alert severity="error" key={20}>
      Die maximale Breite ({parameter} mm) wurde überschritten. Bitte wählen Sie ein anderes Maß.
    </Alert>
  ),
  21: (
    <Alert severity="error" key={21}>
      Die maximale Länge ({parameter} mm) wurde überschritten. Bitte wählen Sie ein anderes Maß.
    </Alert>
  ),
  22: (
    <Alert severity="error" key={22}>
      Die minimale Länge ({parameter} mm) wurde unterschritten. Bitte wählen Sie ein anderes Maß.
    </Alert>
  ),
  23: (
    <Alert severity="error" key={23}>
      Die maximale Tiefe ({parameter} mm) wurde überschritten. Bitte wählen Sie ein anderes Maß.
    </Alert>
  ),
  24: (
    <Alert severity="error" key={24}>
      Die minimale Tiefe ({parameter} mm) wurde unterschritten. Bitte wählen Sie ein anderes Maß.
    </Alert>
  ),
});

export default templates;
